import { render, staticRenderFns } from "./AnimatedCheckbox.vue?vue&type=template&id=895b0478&scoped=true"
var script = {}
import style0 from "./AnimatedCheckbox.vue?vue&type=style&index=0&id=895b0478&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895b0478",
  null
  
)

export default component.exports